import { useEffect, useState } from "react";
import ConfettiExplosion from "react-confetti-explosion";
import { LPLogoWName, Selfie2 } from "../../assets/index";
import { Confetti } from "../../constants/common";
import styles from "./styles";
import LocalStorage from "@Utils/storage";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@Constants/routes";

const IgConnected = () => {
  const [isExploding, setIsExploding] = useState(false);

  useEffect(() => {

    document.title = "LinkPlease - Dashboard | Instagram Connected";

    setTimeout(() => {
      setIsExploding(true);
    }, Confetti.DELAY);
    setTimeout(() => {
      setIsExploding(false);
    }, Confetti.DURATION);
  }, []);

  const navigate = useNavigate();

  const takeToDashboard = () => {
    LocalStorage.removeItem('ppu')
    LocalStorage.removeItem('igu')
    navigate(ROUTES.DASHBOARD)
  }

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-cover bg-center bg-no-repeat bg-fixed" 
      style={styles.LOGIN_CONTAINER}>
      <div className="w-[90%] max-w-[500px] flex flex-col items-center bg-white p-8 rounded-2xl shadow-lg">
        <div className="mb-8">
          <img src={LPLogoWName} className="w-[250px]" alt="Linkplease Logo" />
        </div>
        <div className="flex-col w-full relative">
          {isExploding && (
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50">
              <ConfettiExplosion
                force={Confetti.FORCE}
                duration={Confetti.DURATION}
                particleCount={Confetti.PARTICLE_COUNT}
                width={Confetti.WIDTH}
              />
            </div>
          )}
          <div className="container-msg flex flex-col justify-center items-center my-[2rem]">
            <img 
              className="w-16 h-16 rounded-full object-cover mb-4 shadow-md"
              src={LocalStorage.getItem('ppu') || ''} 
              alt="Profile" 
            />
            <h1 className="text-[1.2rem] font-semibold text-center mb-2">
              Congratulations! 🎉
            </h1>
            <p className="text-center text-[#787781] mb-4">
              @{LocalStorage.getItem('igu') || ''} is successfully connected!
            </p>
          </div>
          <button 
            className="w-full bg-[#7772FF] text-white py-3 rounded-lg font-medium hover:bg-[#6561FF] transition-colors"
            onClick={takeToDashboard}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default IgConnected;
